import Axios from "axios";
import { toast } from "react-toastify";
import useAuthStore from "../store/login/useAuthStore";

import { NEXT_PUBLIC_BASE_PREFIX, NEXT_PUBLIC_BASE_URL } from "./urls";
const AxiosT = Axios.create({
  baseURL: `${NEXT_PUBLIC_BASE_URL + NEXT_PUBLIC_BASE_PREFIX}`,
});

AxiosT.interceptors.response.use(
  (res) => {
    if (res?.config?.method !== "get") {
      if (res?.data.status.code === -1) {
        toast.error(res?.data?.status.msg);
      }
    }
    return res;
  },
  (err) => {
    if (err?.response?.config.method !== "get") {
      toast.error(err?.response.data.error);
    }
    return Promise.reject(err);
  }
);

AxiosT.defaults.headers.post["Content-Type"] = "application/json";
export default AxiosT;
